<template>

  <t-page>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 msg-return-gender-feminine
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage">

      <template #search>
        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'"
                  primary/>
        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         placeholder="Despesa, Credor, ..."
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">

          <t-input-search v-model="form.issueDate" enable-range date label="Data de Emissão"/>


          <t-input label="Tipo" hide-label radio v-model="form.typeRelation" :options="ExpenseRelationType.list"/>

          <t-input-person creditor
                          v-show="form.typeRelation === ExpenseRelationType.type.CREDITOR"
                          v-model="form.creditorId"/>

          <t-input-person supplier
                          v-show="form.typeRelation === ExpenseRelationType.type.SUPPLIER"
                          v-model="form.supplierId"/>


        </t-content-header-search-default>

      </template>

      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="fields"
               link-primary-column="expenseNumber"
               primary-key-column="expenseNumber">

        <template #first-column="{item}">

          <t-list-link-primary formatter="lpad:4"
                               :label="item.expenseNumber" :userAuth="userAuth" :id="item.expenseNumber"
                               :path="currentPage.path"/>


        </template>


      </t-table>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import http from "@/services/config/http-common";
import ExpenseRelationType from "@/model/types/modules/financial/ExpenseRelationType";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'Expense',
  data() {
    return {
      ExpenseRelationType,
      path: "", //Utilizar somente quando fora do padrão
      form: {
        customerId: 0,
        companyId: 0,
        typeRelation: 1,
        creditorId: 0,
        supplierId: 0,
        chartAccountId: 0,
        invoiceId: 0,
        purchaseInvoiceId: 0,
        receiptNumber: 0,
        issueDate: "",
        statusCash: 1,
      },
      fields: [
        {key: "expenseNumber", label: "Cód. Despesa"},
        {key: "typeRelationDescription", label: "Fornecedor/Credor"},
        {key: "qtyItems", label: "Qtd. Itens"},
        {key: "amount", label: "Valor Total", formatter: "number"},
        {key: "statusCash", label: "Status"},
        {key: "actions", label: ""},
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      companyOptions: [],
      //--------------------------------------------------------------------------------------

    }
  },
  methods: {

    mountedPrepare() {
      delete this.form.status
    },
    async mountedContinued() {

      await http.list(this.userAuth.currentPage.path + "/selectRelationList").then((response) => {
        this.companyOptions = response.companyOptions
      }).catch(error => this.responseError(error))

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()


  },
}
</script>
